var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSettingsGear24(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 20.5C16.4183 20.5 20.5 16.4183 20.5 12C20.5 7.58172 16.4183 3.43644 12 3.43644C7.58172 3.43644 3.5 7.58172 3.5 12C3.5 16.4183 7.58172 20.5 12 20.5ZM12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8356 0.986394C10.9305 0.41719 11.4229 0 12 0C12.5771 0 13.0695 0.41719 13.1644 0.986394L13.5 3H10.5L10.8356 0.986394Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8356 23.0136C10.9305 23.5828 11.4229 24 12 24C12.5771 24 13.0695 23.5828 13.1644 23.0136L13.5 21H10.5L10.8356 23.0136Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0.986394 13.1644C0.41719 13.0695 0 12.5771 0 12C0 11.4229 0.41719 10.9305 0.986394 10.8356L3 10.5V13.5L0.986394 13.1644Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0136 13.1644C23.5828 13.0695 24 12.5771 24 12C24 11.4229 23.5828 10.9305 23.0136 10.8356L21 10.5V13.5L23.0136 13.1644Z",
    fill: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5.8771 3.43644C5.67466 2.89606 5.89256 2.28853 6.3923 2C6.89205 1.71147 7.52714 1.82653 7.8939 2.27204L9.19134 3.84808L6.59327 5.34808L5.8771 3.43644Z",
    fill: "currentColor"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8907 22.5126C17.2575 22.9581 17.8926 23.0731 18.3923 22.7846C18.892 22.4961 19.11 21.8885 18.9075 21.3482L18.1913 19.4365L15.5933 20.9365L16.8907 22.5126Z",
    fill: "currentColor"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M3.43644 18.9075C2.89606 19.11 2.28853 18.892 2 18.3923C1.71147 17.8926 1.82653 17.2575 2.27204 16.8907L3.84808 15.5933L5.34808 18.1913L3.43644 18.9075Z",
    fill: "currentColor"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5126 7.8939C22.9581 7.52714 23.0731 6.89205 22.7846 6.3923C22.4961 5.89256 21.8885 5.67466 21.3482 5.8771L19.4365 6.59327L20.9365 9.19134L22.5126 7.8939Z",
    fill: "currentColor"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M2.27204 7.89347C1.82653 7.52671 1.71147 6.89162 2 6.39188C2.28853 5.89213 2.89606 5.67423 3.43644 5.87667L5.34808 6.59284L3.84808 9.19091L2.27204 7.89347Z",
    fill: "currentColor"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3482 18.9071C21.8885 19.1095 22.4961 18.8916 22.7846 18.3919C23.0731 17.8921 22.9581 17.257 22.5126 16.8903L20.9365 15.5928L19.4365 18.1909L21.3482 18.9071Z",
    fill: "currentColor"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M7.8939 22.5121C7.52714 22.9576 6.89205 23.0727 6.3923 22.7842C5.89256 22.4957 5.67466 21.8881 5.8771 21.3477L6.59327 19.4361L9.19134 20.9361L7.8939 22.5121Z",
    fill: "currentColor"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9075 3.43601C19.11 2.89563 18.892 2.2881 18.3923 1.99957C17.8926 1.71104 17.2575 1.8261 16.8907 2.27161L15.5933 3.84765L18.1913 5.34765L18.9075 3.43601Z",
    fill: "currentColor"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 13.5C12.8284 13.5 13.5 12.8284 13.5 12C13.5 11.1716 12.8284 10.5 12 10.5C11.1716 10.5 10.5 11.1716 10.5 12C10.5 12.8284 11.1716 13.5 12 13.5ZM12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15Z",
    fill: "currentColor"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.25 9.5V3H12.75V9.5H11.25Z",
    fill: "currentColor"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.56647 16.1454L9.87041 12.388L10.7375 13.612L5.43357 17.3694L4.56647 16.1454Z",
    fill: "currentColor"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.7375 16.1454L14.4335 12.388L13.5665 13.612L18.8704 17.3694L19.7375 16.1454Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingsGear24);
export default __webpack_public_path__ + "static/media/settingsGear-24.55468e8d.svg";
export { ForwardRef as ReactComponent };